import React, { Component } from "react";
import ContentWrapper from "../../../../components/common/ContentWrapper.js";
import "../../../../components/admin/css/common.css";
import { history } from "../../../../helper/history.js";
import Levels from "../Levels.js";
import LevelGrade from "../LevelGrades.js";
import AssessCreditPackages from "../AssessCreditPack.js";
import Subscription from "../LevelPrice.js";
import AssessCreditPackagePrice from "../AssessCreditPackPrice.js";
import Transactions from "./Transactions.js";
import ExamTransactions from "./ExamTransactions.js";
import PackageTransactions from "./PackageTransactions.js";
import Credits from "./Credits.js";
import AssessmentCreditnew from "./AssessmentCreditnew.js";
import CreditPackages from "./CreditPackages.js"
import AssessmentUserCreditPackages from "./AssessmentCreditPack.js"
import { TreeMainService } from "../../../../service/manage/h_tree/tree_main.service.js";
import { CombankService } from "../../../../service/manage/subscription/combank_pg.service.js";
import Spinner from "react-bootstrap/Spinner";
import config from "../../../../helper/config.js";
import { customerConstants } from "../../../../helper/constants.js";
import { sweetStatusAlert, sweetConfirmAlert } from "../../../../components/common/SweetAlert";
import CreditBuyLimitManage from "./CreditBuyLimitManage.js";
import "../../../../pages/manage/dashboard/edsider/TheStudentDashboard/Components/TheStudentDashboard.css";


const getCustomerFeatureFlag = () => {
	return config.customerConfigs.featureFlag;
};

let tabTextColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
	case customerConstants.EXO_CUSTOMER1:
		tabTextColor = "var(--maincolor)";
		break;
	case customerConstants.EXO_CUSTOMER2:
		tabTextColor = "var(--maincolor-cmc)";
		break;
	default:
		tabTextColor = "var(--maincolor)";
		break;
}

const privileges = {
	tabVisibility: false,
	addVisibility: false,
	editVisibility: false,
	deleteVibility: false,
	viewVisibility: false,
	isAdmin: false,
	isStudent: false,
	isParent: false,
};

export default class ManageAssessSubscription extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: "",
			showInsertModal: false,
			showModal: false,
			isLoading: false,
			isTableDataLoading: true,
			isModified: false,
			selectedStudentId: "",
			selectedStudentTable: "",
			selectedStudent: null,
			search_id: "",
			isStudentsLoading: false,
			isSubmitting: false,
			registration_id: "",
			editVisibility: false,
			addVisibility: false,
			packages: null,
			type: "",
			credits: "",
			amount: "",
			currency: "",
			period: "",
			selectedStudent: null,
			selectedPackage: null,
			userType: "",
			levelPrivilege: privileges,
			levelGradePrivilege: privileges,
			typesPrivilege: privileges,
			levelPricePrivilege: privileges,
			creditsPrivilege: privileges,
			transactionsPrivilege: privileges,
			target_tab_id: 0
		};
	}

	handleTabChange = (event, newValue) => {
		this.setState({ activeTab: newValue });
	};

	componentDidMount() {
		this.setState({ isLoading: true });
		// Handle payment response if any
		this.handlePaymentResponse();

		const privilege_add = this.props.state?.privilege_add
		const privilege_edit = this.props.state?.privilege_edit
		const privilege_view = this.props.state?.privilege_view
		const privilege_delete = this.props.state?.privilege_delete


		const lg_user_table_id = sessionStorage.getItem("table_log_id")

		TreeMainService.getUserType(lg_user_table_id).then((response) => {
			this.setState(
				{
					userType: response.data?.userType,
				},
				() => {
					this.getVisibilityCheck(privilege_add, privilege_edit);
					this.setRoleBasedPrivilege(
						privilege_add,
						privilege_edit,
						privilege_view,
						privilege_delete
					);
				}
			);
		});
		// // Handle payment response if any
		// this.handlePaymentResponse();
	}

	handlePaymentResponse = () => {
		this.setState({ isLoading: true });
		const query = new URLSearchParams(window.location.search);
		const success = query.get('success');
		const cancel = query.get('cancel');
		if (success === 'true') {
			// Get checkout session ID from storage
			const checkoutSessionId = sessionStorage.getItem("checkout_session_id");
			CombankService.retrieveOrderForAssessmentPackagePurchase(checkoutSessionId)
				.then((response) => {
					sessionStorage.removeItem('checkout_session_id');
					query.delete('success');
					sweetStatusAlert("Success!", "Your payment was successful!", "success").then(() => {
						// this.setState({ isLoading: false });
						this.updateUrl(query);
						const tab_param = this.props.state?.tab_param ? this.props.state.tab_param : 0
						this.setState({ activeTab: tab_param })
						this.setState({ isLoading: false });
					});
					// this.updateUrl(query);
				});
		} else if (cancel === 'true') {
			query.delete('cancel');
			sweetStatusAlert("", "You are back to EdSider Subscriptions!", "info");
			this.updateUrl(query);
			const tab_param = this.props.state?.tab_param ? this.props.state.tab_param : 1
			this.setState({ activeTab: tab_param })
			this.setState({ isLoading: false });
		} else {
			const tab_param = this.props.state?.tab_param ? this.props.state.tab_param : 0
			this.setState({ activeTab: tab_param })
			this.setState({ isLoading: false });
		}
	}

	updateUrl = (query) => {
		const newQueryString = query.toString();
		const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
		window.history.replaceState({}, document.title, newUrl);
	}

	getVisibilityCheck(privilege_add, privilege_edit) {
		if (privilege_add == "1") {
			this.setState({
				addVisibility: true,
			});
		}
		if (privilege_edit == "1") {
			this.setState({
				editVisibility: true,
			});
		}
	}

	setRoleBasedPrivilege(
		privilege_add,
		privilege_edit,
		privilege_view,
		privilege_delete
	) {
		const { userType } = this.state;

		const levelPrivilege = {
			tabVisibility: true,
			addVisibility: privilege_add && userType === "admin",
			editVisibility: privilege_edit && userType === "admin",
			deleteVibility: privilege_delete && userType === "admin",
			viewVisibility:
				(privilege_view && userType === "admin") ||
				(privilege_view && userType === "student") ||
				(privilege_view && userType === "parent"),
			isAdmin: userType === "admin",
			isStudent: userType === "student",
			isParent: userType === "parent",
		};

		const levelGradePrivilege = {
			tabVisibility: true,
			addVisibility: privilege_add && userType === "admin",
			editVisibility: privilege_edit && userType === "admin",
			deleteVibility: privilege_delete && userType === "admin",
			viewVisibility:
				(privilege_view && userType === "admin") ||
				(privilege_view && userType === "student"),
			isAdmin: userType === "admin",
			isStudent: userType === "student",
			isParent: userType === "parent",
		};

		const typesPrivilege = {
			tabVisibility: userType === "admin",
			addVisibility: privilege_add && userType === "admin",
			editVisibility: privilege_edit && userType === "admin",
			deleteVibility: privilege_delete && userType === "admin",
			viewVisibility:
				(privilege_view && userType === "admin") ||
				(privilege_view && userType === "student") ||
				(privilege_view && userType === "parent"),
			isAdmin: userType === "admin",
			isStudent: userType === "student",
			isParent: userType === "parent",
		};

		const levelPricePrivilege = {
			tabVisibility: userType === "admin",
			addVisibility: privilege_add && userType === "admin",
			editVisibility: privilege_edit && userType === "admin",
			deleteVibility: privilege_delete && userType === "admin",
			viewVisibility:
				(privilege_view && userType === "admin") ||
				(privilege_view && userType === "student") ||
				(privilege_view && userType === "parent"),
			isAdmin: userType === "admin",
			isStudent: userType === "student",
			isParent: userType === "parent",
		};

		const creditsPrivilege = {
			tabVisibility:
				userType === "admin" || userType === "student" || userType === "parent",
			addVisibility:
				(privilege_add && userType === "student") ||
				(privilege_add && userType === "parent") ||
				(privilege_add && userType === 'admin'),
			editVisibility:
				(privilege_edit && userType === "student") ||
				(privilege_edit && userType === "parent"),
			deleteVibility:
				(privilege_delete && userType === "student") ||
				(privilege_delete && userType === "parent"),
			viewVisibility:
				(privilege_view && userType === "student") ||
				(privilege_view && userType === "parent"),
			isAdmin: userType === "admin",
			isStudent: userType === "student",
			isParent: userType === "parent",
		};

		const transactionsPrivilege = {
			tabVisibility:
				userType === "admin" || userType === "student" || userType === "parent",
			addVisibility: privilege_add && userType === "admin",
			editVisibility: privilege_edit && userType === "admin",
			deleteVibility: privilege_delete && userType === "admin",
			viewVisibility:
				(privilege_view && userType === "admin") ||
				(privilege_view && userType === "student") ||
				(privilege_view && userType === "parent"),
			isAdmin: userType === "admin",
			isStudent: userType === "student",
			isParent: userType === "parent",
		};

		this.setState({
			levelPrivilege: levelPrivilege,
			levelGradePrivilege: levelGradePrivilege,
			typesPrivilege: typesPrivilege,
			levelPricePrivilege: levelPricePrivilege,
			creditsPrivilege: creditsPrivilege,
			transactionsPrivilege: transactionsPrivilege,
			// activeTab:
			//     userType === "admin"
			//     ? 0
			//     : userType === "student"
			//         ? 0
			//         : userType === "parent"
			//         ? 0
			//         : 0,
		});
	}

	render() {
		const path = history.location.pathname;
		const {
			levelPrivilege,
			levelGradePrivilege,
			typesPrivilege,
			levelPricePrivilege,
			creditsPrivilege,
			isLoading,
			transactionsPrivilege,
			userType,
		} = this.state;
		return (
			<div>
				<ContentWrapper disabled={path === "/manage-search"}>
					{(!userType || isLoading) ? (
						<div className="loading-container">
							<Spinner animation="border" role="status">
								<span className="sr-only">Loading...</span>
							</Spinner>
						</div>
					) : (
						<div>
							{userType && userType === "admin" ? (
								<div>
									<div className="paper-tabs">
										{typesPrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 0 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 0)}
											>
												Credit Packages
											</button>
										)}
										{levelPricePrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 1 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 1)}
											>
												Credit Prices
											</button>
										)}
										{transactionsPrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 2 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 2)}
											>
												User Package Subscriptions
											</button>
										)}
										{transactionsPrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 3 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 3)}
											>
												User Assessment Purchasings
											</button>
										)}
										{transactionsPrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 4 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 4)}
											>
												Set Maximum limit For Buying Credit Packages
											</button>
										)}
									</div>
									{this.state.activeTab === 0 && typesPrivilege && (
										<AssessCreditPackages
											props={this.props.state}
											typesPrivilege={typesPrivilege}
										></AssessCreditPackages>
									)}

									{this.state.activeTab === 1 && levelPricePrivilege && (
										<AssessCreditPackagePrice
											props={this.props.state}
											levelPricePrivilege={levelPricePrivilege}
										></AssessCreditPackagePrice>
									)}
									{this.state.activeTab === 2 && transactionsPrivilege && (
										<PackageTransactions
											props={this.props.state}
											transactionsPrivilege={transactionsPrivilege}
										></PackageTransactions>
									)}
									{this.state.activeTab === 3 && transactionsPrivilege && (
										<ExamTransactions
											props={this.props.state}
											transactionsPrivilege={transactionsPrivilege}
										></ExamTransactions>
									)}
									{this.state.activeTab === 4 && transactionsPrivilege && (
										<CreditBuyLimitManage></CreditBuyLimitManage>
									)}
								</div>
							) : (
								<div>
									<div className="paper-tabs">
										{creditsPrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 0 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 0)}
											>
												{userType === "student" ? "My Subscription" : "Subscriptions"}
											</button>
										)}
										{creditsPrivilege.tabVisibility && (
											<button
												className={`MuiTab-root ${this.state.activeTab === 1 ? 'Mui-selected' : ''}`}
												onClick={() => this.handleTabChange(null, 1)}
											>
												Buy Credits
											</button>
										)}
									</div>

									{this.state.activeTab === 0 && creditsPrivilege && (
										<AssessmentCreditnew
											props={this.props.state}
											creditsPrivilege={creditsPrivilege}
											onTabChange={this.handleTabChange}
										></AssessmentCreditnew>
									)}
									{this.state.activeTab === 1 && creditsPrivilege && (
										<AssessmentUserCreditPackages
											props={this.props.state}
											creditsPrivilege={creditsPrivilege}
										></AssessmentUserCreditPackages>
									)}
									{/* {this.state.activeTab === 2 && transactionsPrivilege && (
										<Transactions
										props={this.props.state}
										transactionsPrivilege={transactionsPrivilege}
										></Transactions>
									)} */}
									{/* {this.state.activeTab === 2 && transactionsPrivilege && (
										<PackageTransactions
											props={this.props.state}
											transactionsPrivilege={transactionsPrivilege}
										></PackageTransactions>
									)} */}
									{/* {this.state.activeTab === 3 && transactionsPrivilege && (
										<ExamTransactions
											props={this.props.state}
											transactionsPrivilege={transactionsPrivilege}
										></ExamTransactions>
									)} */}
								</div>
							)}
						</div>
					)}
				</ContentWrapper>
			</div>
		);
	}
}
